import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "filter-and-search-panel",
  class: "filter-and-search uk-padding-small"
}
const _hoisted_2 = { class: "uk-flex" }
const _hoisted_3 = { class: "uk-flex" }
const _hoisted_4 = { class: "per-page-selector uk-margin-small-right" }
const _hoisted_5 = { class: "tags-selector uk-margin-small-right" }
const _hoisted_6 = { class: "target-selector uk-margin-small-right" }
const _hoisted_7 = { class: "group-selector" }
const _hoisted_8 = { class: "search-input uk-width-1-4" }
const _hoisted_9 = ["placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_per_page_selector = _resolveComponent("per-page-selector")!
  const _component_multiselect = _resolveComponent("multiselect")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_per_page_selector, {
            class: "filter-multiselect",
            onSelected: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('perPageChanged')))
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_multiselect, {
            modelValue: _ctx.tags,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tags) = $event)),
            mode: "tags",
            multiple: "",
            "close-on-select": false,
            searchable: true,
            "create-option": true,
            options: _ctx.config.tags,
            placeholder: 
              _ctx.$t('index_templates.filter_and_search.tags.placeholder')
            ,
            "show-labels": false,
            class: "filter-multiselect"
          }, null, 8, ["modelValue", "options", "placeholder"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_multiselect, {
            modelValue: _ctx.target,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.target) = $event)),
            options: _ctx.config.targets,
            placeholder: 
              _ctx.$t('index_templates.filter_and_search.target.placeholder')
            ,
            class: "filter-multiselect",
            "custom-label": _ctx.customTargetLabel,
            "show-labels": false
          }, null, 8, ["modelValue", "options", "placeholder", "custom-label"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_multiselect, {
            modelValue: _ctx.group,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.group) = $event)),
            options: _ctx.config.groups,
            placeholder: 
              _ctx.$t('index_templates.filter_and_search.group.placeholder')
            ,
            class: "filter-multiselect",
            "show-labels": false
          }, null, 8, ["modelValue", "options", "placeholder"])
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchQuery) = $event)),
          class: "uk-input",
          type: "text",
          placeholder: 
            _ctx.$t('index_templates.filter_and_search.search.placeholder')
          
        }, null, 8, _hoisted_9), [
          [
            _vModelText,
            _ctx.searchQuery,
            void 0,
            { lazy: true }
          ]
        ])
      ])
    ])
  ]))
}